import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55589891&"
import script from "./recall.ts?vue&type=script&lang=js&"
export * from "./recall.ts?vue&type=script&lang=js&"
import style0 from "./recall.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports